<template>
    <div id="main" class="is-flex">
        <div class="page page-container">
            <div class="vertical-flow">
                <!-- TÍTULO E BREADCRUMB -->
                <h1 class="title"> {{ !isLoading ? (rota && rota.idrotavisita) ? $t('rota') : $t('nova-rota') : '...' }}</h1>
                <nav class="breadcrumb" aria-label="breadcrumbs">
                    <ul>
                        <li><a class="a-inativo">{{$t('vendas')}}</a></li>
                        <li><a class="a-inativo">{{$t('cadastros')}}</a></li>
                        <li><a @click="$router.push({name: 'ven-rotavisitas'})">{{$t('routes')}}</a></li>
                        <li><a aria-current="page">{{ !isLoading ? ((rota && rota.idrotavisita) ? rota.descricao : $t('nova-rota')) : '...' }}</a></li>
                    </ul>
                </nav>

                <!-- ABAS -->
                <ul class="nav nav-tabs">
                    <li
                        v-for="(aba, i) in abas"
                        :class="{'active': abaSelecionada == i}"
                        :key="i"
                        @click="abaSelecionada = i"
                    >
                        <a data-toggle="tab" :href="`#${aba}`">{{$t(aba)}}</a>
                    </li>
                </ul>

                <!-- ABA GERAL -->
                <Geral v-if="dataLoaded || !isUpdate"
                    ref="abaGeral"
                    v-show="abas[abaSelecionada] == 'geral' && abaGeralLoaded"
                    :disabled="$store.getters.isLoading || isLoading || isSaving || isSaved || assRotaClienteIntegracao"
                    :descricao.sync="rota.descricao"
                    :usuario.sync="rota.usuario"
                    :datainicio.sync="rota.datainiciostr"
                    :tipo-frequencia.sync="rota.tipoFrequencia"
                    :frequencia.sync="rota.frequencia"
                    :obriga-sequencia.sync="rota.obrigaSequencia"
                    :permite-avulso.sync="rota.permiteAvulso"
                    :situacao.sync="rota.situacao"
                />

                <Mapa
                    ref="abaMapa"
                    v-show="abas[abaSelecionada] == 'mapa'"
                    :rota="rota.clientes"
                    :clientes="clientesUsuarioWithoutLimit"
                    :disabled="isLoadingClientes || isLoading"
                    @add-clientes="addClientes"
                    @remove-cliente="removeCliente"
                    @update="updateClientes"
                />

                <Clientes
                    ref="abaCliente"
                    v-show="abas[abaSelecionada] == 'clientes'"
                    :rota="rota.clientes"
                    :clientes="clientesUsuario"
                    :totalRows="totalRowsClientes"
                    @add-clientes="addClientes"
                    @updateList="updateListClientesEvent"
                    @remove-cliente="removeCliente"
                    @change-periodo="changePeriodo"
                    @change-observacao="changeObservacao"
                    @update-filtro="updateFiltro"
                    @carregar-clientes="carregarClientes"
                    @add-all-clientes="addAllClientes"
                    @remove-all-clientes="removeAllClientes"
                />

                <!-- BOTÕES SUPERIORES -->
                <div class="form-buttons">
                    <button class="delete-btn" type="button" @click="$router.push({name: 'ven-rotavisitas'})">
                        {{ $t('voltar') }}
                    </button>
                    <button v-show="(allowedCreateRoute || allowedUpdateRoute) && !rotaIntegracao" class="save-btn" type="button" @click="save()" :disabled="isSaving || isSaved">
                        {{ $t('salvar') }}
                        <button-loader :isSaving="isSaving" />
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import RotaVisitaService from "@/services/RotaVisitaService";
import ColaboradorService from "@/services/ColaboradorService";
import RotaVisitaValidation from "@/services/validations/RotaVisitaValidation";
import Geral from "@/components/vendas/rotas/Geral";
import Mapa from "@/components/vendas/rotas/Mapa";
import Clientes from "@/components/vendas/rotas/Clientes"

export default {
    components: {
        Geral, 
        Mapa, 
        Clientes
    },
    data() {
        return {
            rotaIntegracao:
                this.$store.state.user.tabelasERPWebServer.includes("ROTAVISITA"),
            assRotaClienteIntegracao: this.$store.state.user.tabelasERPWebServer.includes("ASSROTAVISITACLIENTE"),
            id: this.$route.params.id,
            abas: ['geral'],
            abasAposCadastro: ['mapa', 'clientes'],
            abaSelecionada: 0,
            service: new RotaVisitaService(this.$http, this.$router),
            colaboradorService: new ColaboradorService(this.$http, this.$router),
            validation: new RotaVisitaValidation(this.$root.msgs),
            isSaving: false,
            isSaved: false,
            isLoading: true,
            isLoadingClientes: false,
            totalRowsClientes: 0,
            updateListClientes : false,
            componentUpdate : null,
            rota: {
                descricao: '',
                situacao: 0,
                tipoFrequencia: 1,
                frequencia: '7',
                obrigaSequencia: 0,
                permiteAvulso: 0,
                datainicio: this.$moment().add(1, 'days').format("YYYY-MM-DD"),
                datainiciostr: this.$moment().add(1, 'days').format("YYYY-MM-DD"),
                clientes: []
            },
            clientesUsuario: [],
            clientesUsuarioWithoutLimit: [],
            filtros: {
                search: '',
                atividades: [],
                situacoes: [],
                cidades: [],
                regioes: []
            },
            permissao: {},
            isUpdate: this.$route.params.id != null,
            abaGeralLoaded: false,
            dataLoaded: false,
        }
    },

    computed: {
        allowedCreateRoute() {
            return !this.isUpdate
                && this.permissao.create;
        },
        allowedUpdateRoute() {
            return this.isUpdate
                && this.permissao.update;
        },
    },
    created () {
        this.permissao = this.hasPermissionAccess('vendas', 'rota', 'ven-rotavisitas');

        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'routes' }
            });
        } else if (!this.isUpdate && !this.allowedCreateRoute) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'routes' }
            });
        }
        if (this.id) {
            this.abas = this.abas.concat(this.abasAposCadastro);
            this.carregarDados(true);
        } else {
            this.isLoading = false;
            this.abaGeralLoaded = true;
        }
    },
    methods: {
        navigateTab(name) {
            let idx = this.abas.findIndex(e => e == name);

            if (idx > -1) {
                this.abaSelecionada = idx;
            }
        },
        carregarDados(navigateToTab = false) {
            if (this.id) {
                /*  Depois que tudo estiver carregado, caso necessário, pega o que tem depois
                    do # na URL ($route.hash) para ver se coincide com o nome de uma aba para
                    poder trocar pra aquela aba.

                    Isso faz funcionar a URL direcionar a aba.
                    Ex: propriedade/uuid#talhoes irá abrir a abra de talhões automaticamente
                        após o carregamento. */
                if (navigateToTab && this.$route.hash) {
                    let tab = this.$route.hash.replace('#', '');
                    this.navigateTab(tab);
                }

                this.$store.commit('addLoader');
                this.isLoading = true;

                this.service.find(this.id)
                    .then(r => {
                        if (r.content) {
                            this.rota = r.content;

                            if (this.rota.usuario && this.rota.usuario.idusuario) {
                                this.carregarClientes(null);
                                this.carregarClientesWithoutLimit(null);
                            }
                            
                            if (this.abas[this.abaSelecionada] == 'mapa') {
                                this.$nextTick(_ => {
                                    this.$refs.abaMapa.centerOnRoute();
                                });
                            }
                        } else {
                            this.redirect(0);
                            this.$root.showMessage('alert', 'msg-not-found');
                        }
                    })
                    .catch(e => {
                        console.error("Houve um erro ao carregar a rota.", e);
                        this.$root.showMessage('error', 'msg-erro-dados-geral');
                    })
                    .finally(_ => {
                        this.dataLoaded = true;
                        this.$store.commit('removeLoader')
                        this.isLoading = false;
                        this.abaGeralLoaded = true;
                    });
            }
        },
        carregarClientes(pagination) {
            /**
             * Por causa da aba geral, ele executava essa funcão antes de passar pelo carregarDados,
             * e nisso o this.rota não tinha o usuario no objeto, assim dava erro de id undefined.
             */
            if (!this.rota.usuario) return;

            this.$store.commit('addLoader');

            this.isLoadingClientes = true;
            
            this.filtros.search = pagination != null ? pagination.search : '';
    
            let curPage = pagination != null ? pagination.currentPage - 1 : 0;
            let limit = pagination != null ? pagination.perPage : 10;

            /*  A necessidade de enviar os clientes na rota - e em ordem - junto é para que na SQL
                eles sejam retornados no topo da lista.
                
                Foi escolhlido esta maneira ao invés de concatenar os dois arrays (de rota e de cliente) */

            if (this.rota && this.rota.clientes) {
                this.filtros.clientesNaRota = this.rota.clientes.map(e => e.cliente.idcliente);
            }

            this.colaboradorService.getClientes( curPage, limit, this.rota.usuario.id, this.filtros)
                .then(r => {
                    this.clientesUsuario = r.content;
                    this.totalRowsClientes = r.totalElements
                })
                .catch(e => {
                    this.isLoadingClientes = false;
                    console.error("Erro ao carregar clientes.", e);
                })
                .finally(_ => {
                    this.$store.commit('removeLoader');
                    this.isLoadingClientes = false;        
                });
        },
        carregarClientesWithoutLimit(pagination) {
            this.$store.commit('addLoader');

            this.isLoadingClientes = true;
            
            this.filtros.search = pagination != null ? pagination.search : '';
    
            let curPage = pagination != null ? pagination.currentPage - 1 : 0;

            /*  A necessidade de enviar os clientes na rota - e em ordem - junto é para que na SQL
                eles sejam retornados no topo da lista.
                
                Foi escolhlido esta maneira ao invés de concatenar os dois arrays (de rota e de cliente) */

            if (this.rota && this.rota.clientes) {
                this.filtros.clientesNaRota = this.rota.clientes.map(e => e.cliente.idcliente);
            }
            
            this.colaboradorService.getClientesWithoutLimit( curPage, this.rota.usuario.id, this.filtros)
                .then(r => {
                    this.clientesUsuarioWithoutLimit = r.content;
                })
                .catch(e => {
                    console.error("Erro ao carregar clientes.", e);
                })
                .finally(_ => {
                    this.$store.commit('removeLoader');
                    this.isLoadingClientes = false;        
                });
        },
        save() {
            if (this.validation.validate(this.rota, this.$refs)) {
                this.isSaving = true;

                this.rota = this.mapTosave(this.rota, "datainicio", "datainiciostr", "frequencia", "clientes");
                this.rota.datainicio = this.rota.datainiciostr!=null 
                    ? this.$moment(this.rota.datainiciostr).format("YYYY-MM-DD") 
                    : null

                this.rota.clientes.forEach((associativa, i) => {
                    associativa.ordem = i + 1;
                });
    
                this.service.save(this.rota)
                    .then(r => {
                        this.isSaved = true;
                        this.$root.alert({
                            message: this.$t('msg-rotavisita-salva'),
                            onConfirm: () => {this.redirect(0);}
                        });
                    })
                    .catch(e => {
                        if (e.body && e.body.message && e.body.message.startsWith('msg-')) {
                            this.$root.showMessage('error', e.body.message);
                        } else {
                            this.$root.showMessage('error', 'msg-problema-realizar-acao');
                        }
                    })
                    .finally(_ => {
                        this.isSaving = false;
                    });
            }
        },
        redirect(time) {
            setTimeout(() => {
                this.$router.push({ name: "ven-rotavisitas" });
            }, time * 1000);
        },
        updateListClientesEvent(funcao){
            this.componentUpdate = funcao;
        },
        addClientes(newClientes) {
            let novos = this.clientesUsuarioWithoutLimit
                            .filter(e => newClientes.includes(e.id))
                            .map(e => {
                                return {
                                    cliente: e,
                                    idrotavisita: this.id,
                                    observacao: '',
                                    periodoDia: 0
                                }
                            });
            
            this.rota.clientes = this.rota.clientes.concat(novos);
            this.componentUpdate(null);
            
        },
        updateClientes(newRouteArray) {
            this.rota.clientes = newRouteArray;
        },
        removeCliente(id) {
            let index = this.rota.clientes.findIndex(e => e.cliente.id == id);
            this.rota.clientes.splice(index, 1);
        },
        changePeriodo({ periodo, id_cliente }) {
            let index = this.rota.clientes.findIndex(e => e.cliente.idcliente == id_cliente);
            
            if (index > -1) {
                this.rota.clientes[index].periodoDia = periodo;
                this.$refs.abaMapa.updateInfoWindow();
            }
        },
        changeObservacao({ observacao, id_cliente }) {
            let index = this.rota.clientes.findIndex(e => e.cliente.idcliente == id_cliente);

            if (index > -1) {
                this.rota.clientes[index].observacao = observacao;
                this.$refs.abaMapa.updateInfoWindow();
            }
        },
        updateFiltro(filtro){
            this.filtros[filtro.nomeFiltro] = filtro.valor;
        },
        changePage(page){
            this.abaSelecionada = page;
            this.$forceUpdate();
        },
        addAllClientes(filter){
            this.$store.commit('addLoader');
            // Pega todos os clientes filtrados e sem paginação e adiciona na rota.
            this.colaboradorService.getClientesNoPagination( this.rota.usuario.id, this.filtros )
            .then(r => {
                if (r.content) {
                    let allClients = r.content.filter( f => !this.rota.clientes.some(r => r.cliente.idcliente == f.idcliente) )
                                            .map(e => {
                                                return {
                                                    cliente: e,
                                                    idrotavisita: this.id,
                                                    observacao: '',
                                                    periodoDia: 0
                                                }
                                            });
                    
                    this.rota.clientes = this.rota.clientes.concat(allClients);
                } else {
                    this.redirect(0);
                    this.$root.showMessage('alert', 'msg-not-found');
                }
            })
            .catch(e => {
                console.error("Houve um erro ao carregar todos os clientes.", e);
                this.$root.showMessage('error', 'msg-erro-dados-geral');
            })
            .finally(_ => {
                this.$store.commit('removeLoader')
                this.isLoading = false;
            });
        },
        removeAllClientes(){
            // Remove todos os clientes, independente do filtro.
            this.rota.clientes = [];
        }
    },
}
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px 20px 20px;
    height: auto;

    .page {
        position: relative;
        margin-bottom: 20px;
        height: inherit;
        min-height: 100%;

        .nav.nav-tabs {
            margin-bottom: 0;
            margin-left: -20px;
            padding-left: 20px;
        }
    }
}
</style>